import { useQuery } from '@tanstack/react-query';

import API from 'services/api';
import FormSubmitError from 'errors/FormSubmitError';
import ProsforaAuctionVolume from 'types/api/ProsforaAuctionVolume';
import { sortBy } from 'lodash';

export const fetchRfpAuctionVolumes = async (rfpId?: number) => {
  if (rfpId === undefined) {
    throw new Error();
  }

  try {
    const { data: volumes } = await API.get<ProsforaAuctionVolume[]>(`/rfp/${rfpId}/auction-volumes`);

    return sortBy(volumes, 'issuance_number');
  } catch (e) {
    throw new FormSubmitError('An error occurred while sending request to the server. Please try again.');
  }
};

const getQueryKey = (id?: number) => {
  const keys: unknown[] = ['rfp/auction-volumes'];

  if (id !== undefined) {
    keys.push(id);
  }

  return keys;
};

const useProsforaAuctionVolumes = (id?: number) =>
  useQuery(getQueryKey(id), () => fetchRfpAuctionVolumes(id), { enabled: !!id });

useProsforaAuctionVolumes.getQueryKey = getQueryKey;
useProsforaAuctionVolumes.queries = {
  fetchRfpAuctionVolumes,
} as const;

export default useProsforaAuctionVolumes;
